import logo from "../../assets/images/logo.png";
import { Typography } from "@mui/material";
import "./logo.css";
import {useNavigate} from 'react-router-dom';


function Logo({isLogoLable}) {

  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" }); // Smooth scrolling to top
  };

  return (
    <>
      <img
        src={logo}
        alt="Logo"
        className="logoStyle"
        onClick={handleLogoClick}
      />
      {isLogoLable ? (
      <Typography
        variant="h6"
        component="div"
        sx={{
          flexGrow: 1,
          color: "white",
          paddingLeft: "12px",
          cursor: "pointer",
        }}
        onClick={handleLogoClick}
      >
        Investment Tracker
      </Typography>
      ) : (
        <></>
      )}
    </>
  );
};

export default Logo;
